{
  "viralRecording": {
    "status": {
      "loading": "Betöltés...",
      "loadingProcessData": "Folyamatadatok betöltése...",
      "loadingRecordingData": "Rögzítési adatok betöltése..."
    },
    "buttons": {
      "startRecording": "Rögzítés indítása",
      "finishing": "Befejezés...",
      "finishRecording": "Rögzítés befejezése",
      "save": "Mentés",
      "delete": "Törlés",
      "addCondition": "Feltétel hozzáadása",
      "addRule": "Szabály hozzáadása",
      "reorderRule": "Húzza a szabály átrendezéséhez",
      "back": "Vissza",
      "addNewInput": "Bemenet hozzáadása",
      "seeMoreAndChange": "Több megtekintése és módosítás",
      "createStartEvent": "Indító esemény létrehozása"
    },
    "labels": {
      "startEvent": "Indító esemény",
      "previousEvent": "Előző esemény",
      "noDescriptionAvailable": "Nincs elérhető leírás",
      "rule": "Szabály",
      "ruleNumber": "{{number}}. szabály",
      "unclear": "Nem egyértelmű",
      "none": "Nincs",
      "theProcessWillEndHere": "A folyamat itt ér véget.",
      "iReceive": "Kapok",
      "iDo": "Csinálok",
      "iUse": "Használok",
      "iCreate": "Létrehozok",
      "youLabel": "{{name}} (Ön)",
      "event": "Esemény",
      "information": "Információ",
      "untitled": "Névtelen",
      "processStepDescription": "Folyamatlépés leírása",
      "processInformation": "Adja meg a folyamat nevét és leírását",
      "processDetailsOverview": "A folyamat törzsadatainak áttekintése",
      "process": "Tevékenység",
      "decision": "Döntés",
      "defineOutput": "Kimenet meghatározása",
      "unknownUser": "Ismeretlen felhasználó",
      "unknownRole": "Ismeretlen pozíció",
      "processName": "Folyamat neve",
      "description": "Leírás",
      "organizationInfo": "Szervezeti információ",
      "owner": "Folyamatfelelős",
      "createdBy": "Létrehozta",
      "department": "Osztály",
      "timestamps": "Időbélyegek",
      "createdAt": "Létrehozva",
      "updatedAt": "Utolsó frissítés",
      "decisionRules": "Döntési szabályok",
      "clickToOpen": "Kattintson a döntési tábla megnyitásához",
      "clickToEdit": "Kattintson a szerkesztéshez",
      "result": "Eredmény",
      "outputHint": "Mi történik ezután, ha ezek a feltételek teljesülnek? Kérjük, fogalmazza meg személytől függetlenül (Jó: „Általános értékesítési folyamat”, „Speciális értékesítési folyamat”. Rossz: „Átadás Péternek”)."
    },
    "placeholders": {
      "noInputsAddedYet": "Még nincsenek hozzáadott bemenetek",
      "defineProcessStepDescription": "Határozza meg a folyamatlépés leírását...",
      "choose": "Választás",
      "enterCondition": "pl. Rendelési érték > 100€",
      "enterConditionAlt": "pl. Rendelési érték < 100€",
      "enterCondition2": "pl. Ügyféltípus = Prémium",
      "enterCondition2Alt": "pl. Ügyféltípus = Standard",
      "enterOutput": "pl. Automatikusan jóváhagy",
      "enterOutput2": "pl. Vezetői jóváhagyás kérése"
    },
    "sections": {
      "inputsReceived": "Események és információk",
      "helpers": "Segédeszközök"
    },
    "modals": {
      "eventModal": {
        "editEventTitle": "Kezdőesemény szerkesztése",
        "createEventTitle": "Kezdőesemény létrehozása",
        "startEventDescription": "Határozza meg a triggert, amely elindítja ezt a folyamatot.",
        "type": "Típus",
        "trigger": "Kiváltó",
        "eventName": "Esemény neve",
        "selectTrigger": "Kiváltó kiválasztása",
        "selectEventType": "Eseménytípus kiválasztása",
        "enterEventName": "Adja meg az esemény nevét",
        "describeWhatTriggers": "Írja le, mi váltja ki ezt az eseményt"
      },
      "decisionTable": {
        "title": "Döntési tábla",
        "descriptionNew": "Határozzon meg döntési szabályokat egyéni feltételekkel. Minden szabály egy utód kártyát hoz létre.",
        "configureRulesDescription": "Döntési szabályok konfigurálása a feltételek alapján történő következő lépés meghatározásához",
        "emptyCondition": "Üres feltétel",
        "validationMessageNew": "Minden szabálynak tartalmaznia kell legalább egy kitöltött feltételt és egy kimenetet",
        "successorReminder": "Ne felejtse el az utódokat hozzárendelni minden szabályhoz a döntési tábla mentése után",
        "defaultCondition": "{{number}}. feltétel",
        "editColumnName": "Kattintson az oszlopnév szerkesztéséhez",
        "orSeparator": "vagy"
      },
      "inputModal": {
        "editTitle": "Bemenet szerkesztése",
        "viewTitle": "Bemenet megtekintése",
        "addTitle": "Bemenet hozzáadása",
        "description": "Milyen események indítják el ezt a lépést, vagy mire van szükség a végrehajtáshoz (pl. jelentés, mérőszámok stb.)",
        "inputTypeSection": "Bemenet típusa",
        "eventDetails": "Esemény részletei",
        "informationDetails": "Információ részletei",
        "inputTypeEvent": "Esemény",
        "inputTypePreviousOutput": "Információ (Előző lépésből)",
        "informationName": "Információ neve",
        "enterInformationName": "pl. Ügyfél adatok",
        "describeInformation": "Írja le, mit tartalmaz ez az információ",
        "linkToProcessStep": "Összekapcsolás egy folyamatlépéssel",
        "linkToProcessStepHint": "Válassza ki azokat a lépéseket, amelyek eredményének rendelkezésre kell állnia, mielőtt ez a lépés elindulhat.",
        "selectProcessStep": "Lépés keresése...",
        "noCompletedSteps": "Nincs elérhető befejezett lépés",
        "allStepsAlreadyLinked": "Minden elérhető lépés már kapcsolva van",
        "outputLabel": "Kimenet: {{output}}",
        "linkedStepNotFound": "A kapcsolt lépés már nem érhető el",
        "inputType": "Típus",
        "selectInputType": "Válasszon bemeneti típust"
      }
    },
    "helpersHeading": {
      "systems_one": "1 rendszer",
      "systems_other": "{{count}} rendszer",
      "participants_one": "1 résztvevő",
      "participants_other": "{{count}} résztvevő",
      "colleagues_one": "1 kolléga",
      "colleagues_other": "{{count}} kolléga",
      "documents_one": "1 dokumentum",
      "documents_other": "{{count}} dokumentum",
      "addHint": "Hozzáadás",
      "pendingSystem": "Javasolt rendszer",
      "pendingFunction": "Javasolt csapat vagy funkció"
    },
    "tooltips": {
      "input": "Adjon hozzá itt mindent, ami beérkezik, és amire szüksége van a folyamatlépés végrehajtásához: egy esemény, amely kiváltja a lépést (pl. negyedéves megbeszélés), vagy egy információ, amelyet feldolgoz (pl. jelentés vagy mutatószám). A tisztán referenciaanyagok, például az irányelvek, ehelyett a „Dokumentumok” alá tartoznak.",
      "actionType": "Írja le, mi történik ebben a lépésben. Ha ez egy szokványos tevékenység, válassza a „Tevékenység” lehetőséget. Ha a folytatás feltételektől függ (pl. jóváhagyva/elutasítva), válassza a „Döntés” lehetőséget.",
      "helpers": "Mivel és kivel végzi el ezt a lépést? Használt rendszerek, kötelezően bevont személyek és szükséges dokumentumok.",
      "documents": "A dokumentumok csak referenciaként szolgálnak – irányelvek, ellenőrzőlisták, sablonok. Ezek változatlanok maradnak. Amit viszont feldolgoz és továbbad, az „Információként” a bemenethez tartozik."
    }
  },
  "entityPicker": {
    "common": {
      "allFacet": "Mind",
      "noResults": "Nincs találat",
      "recommendedBadge": "AJÁNLOTT",
      "matchInFieldTemplate": "— Találat: {{field}}",
      "statsLine": "{{occurrences}} / {{samples}} felvételben ({{percent}} %)",
      "departmentFilterAll": "Összes osztály",
      "departmentFilterAriaLabel": "Szűrés osztály szerint",
      "departmentFilterPrefix": "Részleg:",
      "fields": {
        "email": "E-mail",
        "description": "Leírás",
        "role": "Pozíció",
        "department": "Osztály",
        "category": "Kategória",
        "type": "Típus",
        "name": "Név"
      },
      "buckets": {
        "recentlyUsed": "Legutóbb használt",
        "recentlyUsedSubtitle_one": "az utolsó felvétele alapján",
        "recentlyUsedSubtitle_other": "az utolsó {{count}} felvétele alapján",
        "selected": "Kiválasztott ({{count}})",
        "pendingSuggestions": "Függő javaslatok"
      },
      "selectedSectionLabel_one": "Kiválasztva ({{count}})",
      "selectedSectionLabel_other": "Kiválasztva ({{count}})",
      "removeChipAriaLabel": "{{name}} eltávolítása",
      "switchToAllLabel": "Összes ({{count}}) megjelenítése",
      "switchToBucketsLabel": "Javaslatok megjelenítése",
      "allGroupSelectedLabel": "Kiválasztva ({{count}})"
    },
    "system": {
      "title": "Rendszerek kiválasztása",
      "description": "Mely rendszereket használja ebben a lépésben? Többszörös választás.",
      "searchPlaceholder": "Rendszer neve, gyártó vagy kategória",
      "empty": "Nincs egyező rendszer",
      "saveSingular": "Mentés (1 rendszer)",
      "savePlural": "Mentés ({{count}} rendszer)",
      "saveZero": "Mentés",
      "requestNewTitle": "Új rendszer kérése",
      "requestNewDescription": "Egy adminisztrátor felülvizsgálja és felveszi a katalógusba.",
      "allGroupRestLabel": "További rendszerek ({{count}})",
      "showAllCtaTitle": "Összes rendszer böngészése",
      "showAllCtaMeta": "{{count}} rendszer · szűrhető kategória szerint",
      "suggestRowTitle": "Nincs a listán?",
      "suggestRowMeta": "Javasoljon új rendszert a könyvtárhoz.",
      "emptyStateCtaWithQuery": "„{{query}}” javaslata új rendszerként",
      "emptyStateCtaBlank": "Új rendszer javaslata",
      "createRowMeta": "Hozzon létre új rendszert.",
      "createCtaWithQuery": "„{{query}}” létrehozása új rendszerként",
      "createCtaBlank": "Új rendszer létrehozása",
      "buckets": {
        "recentlyUsed": "Legutóbb használt",
        "recentlyUsedSubtitle_one": "az utolsó felvétele alapján",
        "recentlyUsedSubtitle_other": "az utolsó {{count}} felvétele alapján",
        "byRole": "A pozíciójában szokásos",
        "byRolePeerCount": "{{count}} azonos pozíciójú kolléga",
        "byProcess": "Ehhez a folyamathoz",
        "byProcessSampleSize": "{{count}} hasonló felvételből",
        "byDepartment": "Az osztályán szokásos",
        "byDepartmentPeerCount": "{{count}} kolléga az Ön osztályán",
        "annotation": {
          "recentlyUsed": "legutóbb Ön használta",
          "byRole": "{{count}} kolléga használja",
          "byProcess": "{{count}} hasonló felvételben",
          "byDepartment": "{{count}} kolléga az Ön osztályán használja"
        }
      },
      "resultCount_one": "{{count}} találat",
      "resultCount_other": "{{count}} találat",
      "helperAvailableAsSuccessor": "Korábban segítőként javasolva"
    },
    "user": {
      "title": "Résztvevők kiválasztása",
      "description": "Válassza ki azokat a személyeket, akik aktívan közreműködnek ebben a lépésben – például négy szem elve szerinti jóváhagyáshoz vagy közös feldolgozáshoz. Több is lehetséges.",
      "searchPlaceholder": "Név, pozíció, részleg vagy e-mail",
      "empty": "Nincs egyező kolléga",
      "saveSingular": "Mentés (1 kolléga)",
      "savePlural": "Mentés ({{count}} kolléga)",
      "saveZero": "Mentés",
      "allGroupRestLabel": "További kollégák ({{count}})",
      "showAllCtaTitle": "Összes kolléga böngészése",
      "showAllCtaMeta": "{{count}} kolléga · szűrhető osztály szerint",
      "buckets": {
        "byRole": "A pozíciójában szokásos",
        "byDepartment": "Az osztályán szokásos",
        "byProcess": "Gyakori ennél a folyamatlépésnél"
      }
    },
    "helper": {
      "title": "Személyek vagy funkciók kiválasztása",
      "description": "Válassza ki, ki működik közre aktívan ebben a lépésben – egyes személyek, vagy egy teljes csapat, illetve funkció. Több is lehetséges.",
      "saveSingular": "Mentés (1 résztvevő)",
      "savePlural": "Mentés ({{count}} résztvevő)",
      "kind": {
        "person": "Személyek",
        "team": "Csapatok",
        "role": "Funkciók"
      }
    },
    "artifact": {
      "title": "Dokumentum kiválasztása",
      "description": "Melyik dokumentumot veszi igénybe ebben a lépésben? Például egy irányelvet vagy ellenőrzőlistát.",
      "searchPlaceholder": "Keres név, leírás, típus és címkék között",
      "empty": "Nincs egyező dokumentum",
      "noDataTitle": "Még nincsenek dokumentumok",
      "noDataMessage": "Hozza létre az első dokumentumát, hogy folyamatlépésekhez tudja kapcsolni.",
      "saveSingular": "Mentés (1 dokumentum)",
      "savePlural": "Mentés ({{count}} dokumentum)",
      "saveZero": "Mentés",
      "allGroupRestLabel": "További dokumentumok ({{count}})",
      "showAllCtaTitle": "Összes dokumentum böngészése",
      "showAllCtaMeta": "{{count}} dokumentum · szűrhető típus szerint",
      "suggestRowTitle": "Nem található?",
      "suggestRowMeta": "Hozzon létre új dokumentumot a könyvtárban",
      "emptyStateCtaWithQuery": "„{{query}}” létrehozása új dokumentumként",
      "emptyStateCtaBlank": "Nem található? Hozzon létre egyet",
      "buckets": {
        "byProcess": "Gyakori ennél a folyamatlépésnél",
        "byType": "Tipikus {{type}} dokumentumok"
      }
    },
    "orgFunction": {
      "buckets": {
        "byDepartment": "Az osztályán szokásos",
        "byProcess": "Gyakori ennél a folyamatlépésnél"
      },
      "helperAvailableAsSuccessor": "Korábban javasolva ehhez a lépéshez"
    },
    "team": {
      "title": "Csapat kiválasztása",
      "description": "Melyik csapat veszi át a következő lépést?",
      "searchPlaceholder": "Név, részleg vagy e-mail",
      "empty": "Nincs egyező csapat",
      "saveSingular": "Mentés (1 csapat)",
      "savePlural": "Mentés ({{count}} csapat)",
      "saveZero": "Mentés",
      "allGroupRestLabel": "További csapatok ({{count}})",
      "showAllCtaTitle": "Összes csapat böngészése",
      "showAllCtaMeta": "{{count}} csapat · szűrhető osztály szerint",
      "suggestRowTitle": "Hiányzik a csapat?",
      "suggestRowMeta": "Javasoljon új csapatot a könyvtárhoz.",
      "emptyStateCtaWithQuery": "„{{query}}” javaslata új csapatként",
      "emptyStateCtaBlank": "Új csapat javaslata",
      "createRowMeta": "Hozzon létre új csapatot.",
      "createCtaWithQuery": "„{{query}}” létrehozása új csapatként",
      "createCtaBlank": "Új csapat létrehozása"
    },
    "role": {
      "title": "Funkció kiválasztása",
      "description": "Melyik funkció veszi át a következő lépést?",
      "searchPlaceholder": "Név, megbízás, részleg vagy e-mail",
      "empty": "Nincs egyező funkció",
      "saveSingular": "Mentés (1 funkció)",
      "savePlural": "Mentés ({{count}} funkció)",
      "saveZero": "Mentés",
      "allGroupRestLabel": "További funkciók ({{count}})",
      "showAllCtaTitle": "Összes funkció böngészése",
      "showAllCtaMeta": "{{count}} funkció · szűrhető osztály szerint",
      "suggestRowTitle": "Hiányzik a funkció?",
      "suggestRowMeta": "Javasoljon új funkciót a könyvtárhoz.",
      "emptyStateCtaWithQuery": "„{{query}}” javaslata új funkcióként",
      "emptyStateCtaBlank": "Új funkció javaslata",
      "createRowMeta": "Hozzon létre új funkciót.",
      "createCtaWithQuery": "„{{query}}” létrehozása új funkcióként",
      "createCtaBlank": "Új funkció létrehozása"
    },
    "externalContact": {
      "title": "Külső kontakt kiválasztása",
      "description": "Melyik külső kontaktnak kerül átadásra a folyamat?",
      "searchPlaceholder": "Név, szervezet, típus, e-mail vagy leírás",
      "empty": "Nincs egyező kontakt",
      "noDataTitle": "Még nincsenek külső kontaktok",
      "noDataMessage": "Adjon hozzá egy első kontaktot (ügyfél, beszállító, partner…), hogy használhassa folyamatlépésekben.",
      "saveSingular": "Mentés (1 kontakt)",
      "savePlural": "Mentés ({{count}} kontakt)",
      "saveZero": "Mentés",
      "allGroupRestLabel": "További kontaktok ({{count}})",
      "showAllCtaTitle": "Összes kontakt böngészése",
      "showAllCtaMeta": "{{count}} kontakt · szűrhető típus szerint",
      "suggestRowTitle": "Nincs a listán?",
      "suggestRowMeta": "Adjon hozzá új külső kontaktot.",
      "emptyStateCtaWithQuery": "„{{query}}” hozzáadása új kontaktként",
      "emptyStateCtaBlank": "Nincs a listán? Adjon hozzá",
      "buckets": {
        "byProcess": "Gyakori ennél a folyamatlépésnél",
        "byType": "Tipikus {{type}} kontaktok"
      }
    },
    "successor": {
      "title": "Következő felelős",
      "breadcrumbAfter": "↳ „{{stepName}}\" után · {{stepNumber}}. lépés",
      "descriptionCollapsed": "Ki vagy mi veszi át a következő folyamatlépést?",
      "descriptionExpanded": "Válasszon, vagy váltson típust.",
      "sectionWhoOrWhat": "Ki vagy mi veszi át?",
      "sectionNotYetDefined": "Még nem meghatározott",
      "sidebarTypeHeading": "Típus",
      "statusReadyToSave": "Készen áll a mentésre.",
      "statusPickToContinue": "Válasszon egy lehetőséget a folytatáshoz.",
      "saveError": "Az utódot nem sikerült menteni. Kérjük, próbálja újra.",
      "ctaConfirmEntity": "Mentés",
      "type": {
        "person": {
          "sublabel": "Egy munkatárs"
        },
        "team": {
          "sublabel": "Egy csapat a szervezetben"
        },
        "role": {
          "sublabel": "Egy funkció a szervezetben"
        },
        "system": {
          "sublabel": "Automatizált lépés"
        },
        "externalContact": {
          "sublabel": "Ügyfél, partner, hatóság"
        },
        "unclear": {
          "sublabel": "A folyamatgazda később dönt"
        },
        "none": {
          "sublabel": "A folyamat itt véget ér"
        }
      },
      "unclear": {
        "cardTitle": "Tisztázatlan — később döntsünk",
        "cardBody": "Jelölje meg a lépést nem egyértelműként. A folyamatgazda értesítést kap a felvétel befejezése után, és akkor dönt arról, ki veszi át a következő lépést.",
        "willBeNotified": "ÉRTESÍTÉST KAP",
        "ctaConfirm": "Megjelölés nyitottként"
      },
      "none": {
        "cardTitle": "Nincs utód",
        "cardBody": "(Folyamat vége)",
        "warning": "Győződjön meg arról, hogy nem várható kimenet egy további lépéshez.",
        "ctaConfirm": "Folyamat befejezése"
      }
    },
    "assignee": {
      "title": "Lépés hozzárendelése",
      "descriptionCollapsed": "Ki vagy mi hajtja végre ezt a folyamatlépést?",
      "descriptionExpanded": "Válasszon, vagy váltson típust."
    },
    "starter": {
      "title": "Folyamatindító hozzáadása",
      "descriptionCollapsed": "Ki vagy mi indítja el ezt a folyamatot?",
      "descriptionExpanded": "Válasszon, vagy váltson típust."
    },
    "reassign": {
      "title": "Következő felelős",
      "descriptionCollapsed": "Ki vagy mi veszi át a következő folyamatlépést?",
      "descriptionExpanded": "Válasszon, vagy váltson típust."
    }
  },
  "recording": {
    "finishDisabled": {
      "title": "Még nem fejezhető be:",
      "missingActionType": "Válaszd ki, mit csinál ez a lépés (feladat vagy döntés)",
      "missingInput": "Adj hozzá legalább egy bemenetet",
      "missingTaskDescription": "Írd le, mit csinálsz ebben a lépésben",
      "missingSuccessor": "Válaszd ki, ki vagy mi következik",
      "missingOutput": "Határozd meg a lépés kimenetét",
      "missingDecisionRule": "Töltsd ki a döntési szabályokat"
    },
    "startDisabled": {
      "title": "Még nem indítható:",
      "missingStartEvent": "Állítsd be az indító eseményt",
      "missingSuccessor": "Válaszd ki, ki vagy mi következik"
    }
  }
}
